
import { Container, Tab, Nav, Form, Button, Modal, InputGroup, Dropdown, Tooltip, OverlayTrigger, Card } from "react-bootstrap";

import axios from 'axios';
import { useProfile } from "../contexts/ProfileContext";
import { useEffect } from "react";
import InputMask from 'react-input-mask';
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useRef } from "react";
import Alert from "./Alert";
import { useNavigate } from "react-router-dom";



const Settings = () => {
	const navigate = useNavigate();
  // State for Profile tab
  const profile = useProfile();
  const [email, setEmail] = useState(profile.email);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const defaultPhoto = "/images/default.png";

  //For paying invoices
  const [showPayInvoiceModal, setShowPayInvoiceModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const cardRef = useRef(null);
  const expRef = useRef(null);
  const cvvRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);



  const [instagram, setInstagram] = useState(profile.instagram);

  // State for Billing tab
  const [cardNumber, setCardNumber] = useState("");
  const [cardExpiry, setCardExpiry] = useState(profile.exp);
  const [cardCvc, setCardCvc] = useState("***");


  const [nextRenewalDate, setNextRenewalDate] = useState("");
  // State for Modals
  const [showModal, setShowModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  // Handlers for modals
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleOpenCancelModal = () => setShowCancelModal(true);
  const handleCloseCancelModal = () => setShowCancelModal(false);

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const handleOpenChangePasswordModal = () => setShowChangePasswordModal(true);
  const handleCloseChangePasswordModal = () => setShowChangePasswordModal(false);

  const [functionError, setFunctionError] = useState("");
  const [functionSuccess, setFunctionSuccess] = useState("");

  const handleSubmitPasswordChange = async () => {
    try {
      const response = await axios.post("https://api.viralgpt.com/auth/settings", {
        oldPassword: oldPassword,
        newPassword: newPassword
      }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        }
      });

	  if (response.data.changes.password) {
		setFunctionSuccess("Your password has been updated");
		setShowChangePasswordModal(false);
		setOldPassword("");
		setNewPassword("");
	  } else {
		setFunctionError("Your password has not been updated. Please check your old password and try again.");
	  }
     
    } catch (e) {
      if (e.response?.data?.error) {
        setFunctionError(e.response.data.error);
      } else {
        setFunctionError("Error updating your password");
      }
    }
  }

  // Handlers
  const handleSaveProfile = async () => {
    try {
		if (newPassword !== confirmPassword) {
			setFunctionError("Passwords do not match!");
			return;
		}

      const x = await axios.post("https://api.viralgpt.com/auth/settings", {
        email: email,
        oldPassword: oldPassword,
        newPassword: newPassword
      }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        }
      });
      setFunctionSuccess("Your profile settings were updated");
    } catch (e) {
      setFunctionError("Error updating your profile");
    }
  };

  const [isAddingCard, setIsAddingCard] = useState(false);

  const handleSaveBilling = async () => {
    console.log("Billing info saved:", {
      cardNumber,
      cardExpiry,
      cardCvc,
    });
    try {
      setIsAddingCard(true);
      const x = await axios.post("https://api.viralgpt.com/purchase/add-card", {
        card: cardNumber,
        exp: cardExpiry,
        cvv: cardCvc,
      }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        }
      });
	  axios.post("https://api.viralgpt.com/pixel", {
		email: profile.email,
		event: "AddPaymentInfo",
		price: 0
	}, {
		withCredentials: true
	  })
      setFunctionSuccess("Your billing information has been updated");
	  window.location.reload();
	  setIsAddingCard(false);
    } catch (error) {
      setFunctionError(error.response.data.error);
	  setIsAddingCard(false);
    }
  };

  

  const handleCancelSubscription = () => {
    // Logic for handling the subscription cancellation (e.g., API call)
    console.log("Subscription cancelled");
    handleCloseCancelModal(); // Close the cancellation modal
	try {
		const cancelSubscription = axios.post("https://api.viralgpt.com/purchase/cancel", {
		}, {
			headers:{
				'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
			}
		})
		setFunctionSuccess("Your subscription has been cancelled. You will no longer be charged.");

	} catch (e) {
		console.error(e)
	}
	
  };

const getRenewalDate = async () => {
	try {
		const renewalDate = await axios.post("https://api.viralgpt.com/purchase/renewal-date", {
		}, {
			headers:{
				'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
			}
		});
		if (renewalDate.status == 200) {
			setNextRenewalDate(renewalDate.data.nextChargeDate);
		} else {
			setNextRenewalDate("No active subscription");
		}
		console.log(renewalDate.data.nextChargeDate);
	} catch (error) {
		console.error("Error fetching renewal date:", error);
		setNextRenewalDate("No active subscription");

	}
}

const handleCardChange = async (profileid, cardid) => {
	try {
		const response = await axios.post("https://api.viralgpt.com/purchase/link-card", {
			profileid: profileid,
			cardid: cardid
		}, {
			headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
			}
		});
		axios.post("https://api.viralgpt.com/pixel", {
			email: profile.email,
			event: "AddPaymentInfo",
			price: 0
		}, {
			withCredentials: true
		})
		setFunctionSuccess("Your linked card has been changed");
		window.location.reload();
	} catch (error) {
		setFunctionError("Error linking card");
	}
}

const deleteCard = async (profileid, cardid) => {
	try {
		const response = await axios.post("https://api.viralgpt.com/purchase/delete-card", {
			profileid: profileid,
			cardid: cardid
		}, {
			headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
			}
		});
		setFunctionSuccess("Your card has been deleted");
		window.location.reload();
	} catch (error) {
		setFunctionError("Error deleting card");
	}
}

const handlePauseSubscription = async (subscriptionid) => {
	try {
		const response = await axios.post("https://api.viralgpt.com/purchase/cancel", {
			subscriptionid: subscriptionid
		}, {
			headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
			}
		});
		setFunctionSuccess("Your subscription has been paused");
		window.location.reload();
	} catch (error) {
		setFunctionError("Error pausing subscription");
	}
}

const handleResumeSubscription = async (subscriptionid) => {
	try {
		const response = await axios.post("https://api.viralgpt.com/purchase/resume", {
			subscriptionid: subscriptionid
		}, {
			headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
			}
		});
		setFunctionSuccess("Your subscription has been resumed");
		window.location.reload();
	} catch (error) {
		setFunctionError("Error resuming subscription");
	}
}

const handlePayInvoice = async (invoiceid, cardid, exp, cvv, card) => {

  setIsLoading(true);
  try {
	let data;
	if (cardid == "addCard") {
		data = {
			invoiceid: invoiceid,
			exp: exp,
			cvv: cvv,
			card: card
		}
	} else {
		data = {
			invoiceid: invoiceid,
			cardid: cardid
		}
	}
    const response = await axios.post("https://api.viralgpt.com/purchase/pay-invoice", data, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
      }
    });
	setFunctionSuccess("Your invoice has been paid");
	window.location.reload();
  } catch (error) {
    setFunctionError("Error paying invoice");
  } finally {
    setIsLoading(false);
  }
}

const unlinkAccount = async (profileid) => {
	try {
		const response = await axios.post("https://api.viralgpt.com/auth/unlink", {
			profileid: profileid
		}, {
			headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
			}
		});
		setFunctionSuccess("Your account has been unlinked");
		window.location.reload();
	} catch (error) {
		setFunctionError(error.response.data.error);
	}
}

const [showUnlinkModal, setShowUnlinkModal] = useState(false);
const [unlinkProfile, setUnlinkProfile] = useState(null);
const [unlinkProfileName, setUnlinkProfileName] = useState(null);






const location = useLocation();
const queryParams = new URLSearchParams(location.search);
const modeParam = queryParams.get("tab");

// We'll ensure it's one of the 3 valid tabs; otherwise default to "likes"
const validModes = ["billing", "profile", "invoices"];
const defaultKey = validModes.includes(modeParam) ? modeParam : "profile";
  




  return (
    <>
      <Container className="py-4" >
        <h1 className="text-4xl font-bold text-gray-800" >
          <span className="text-instagram">ViralGPT</span> Settings
        </h1>
        <p className="text-muted">
          Edit your account information and update billing information.
        </p>

		<Alert 
          variant="danger" 
          message={functionError} 
          show={!!functionError} 
          onClose={() => setFunctionError("")} 
        />

		<Alert 
          variant="success" 
          message={functionSuccess} 
          show={!!functionSuccess} 
          onClose={() => setFunctionSuccess("")} 
        />
		
        <Tab.Container defaultActiveKey={defaultKey} >
          {/* Navigation tabs */}
		  <div class="row">
          <Nav variant="tabs" className="bg-white border d-flex justify-content-center w-100 mb-4">
            <Nav.Item className="flex-fill text-center">
              <Nav.Link eventKey="profile">Account</Nav.Link>
            </Nav.Item>
            <Nav.Item className="flex-fill text-center">
              <Nav.Link eventKey="billing">Billing</Nav.Link>
            </Nav.Item>
			<Nav.Item className="flex-fill text-center">
              <Nav.Link eventKey="invoices">Invoices</Nav.Link>
            </Nav.Item>
          </Nav>
		  </div>
          {/* Tab panes */}
          <Tab.Content >
            {/* Profile Tab */}
            <Tab.Pane eventKey="profile">
             
              <Form className="card p-3 mb-3" autoComplete="off">
			  	<h5>Account Information</h5>
                <InputGroup className="mb-3" size="md">
                  <InputGroup.Text id="password-addon" className="py-3">
                    <i className="fa fa-envelope" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter new email"
                    aria-label="Email"
                    aria-describedby="email-addon"
                  />
                </InputGroup>

                

                

                <div className="d-flex">
                  <Button variant="primary" className="me-3 bg-instagram" onClick={handleSaveProfile}>
                  Save Profile
                  </Button>
                  <Button variant="primary" onClick={handleOpenChangePasswordModal}>
                    Change Password
                  </Button>
                </div>
              </Form>


				<div className="card p-3 mb-3">	
					<h5>Linked Profiles</h5>
					<div className="d-flex flex-wrap gap-2">
						{Object.values(profile.socials).map((social, index) => (
							<div key={index} className="d-flex align-items-center position-relative">
								<OverlayTrigger
									placement="top"
									overlay={
										<Tooltip>
											{social.username}
										</Tooltip>
									}
								>
									<img src={social.photo || defaultPhoto} alt={social.username} className="rounded-circle" style={{width: "50px", height: "50px", objectFit: "cover"}} />
								</OverlayTrigger>
								<button 
									className="position-absolute top-0 end-0 btn btn-sm btn-danger rounded-circle d-flex align-items-center justify-content-center"
									style={{transform: "translate(25%, -25%)", width: "20px", height: "20px", padding: "0"}}
										onClick={() => {
										setShowUnlinkModal(true);
										setUnlinkProfile(social.profileid);
										setUnlinkProfileName(social.username);
									}}
								>
									<i className="fas fa-unlink" style={{fontSize: "0.6rem"}}></i>
								</button>
							</div>
						))}
					</div>
				</div>
				<Modal show={showUnlinkModal} onHide={() => setShowUnlinkModal(false)}>
					<Modal.Header closeButton>
						<Modal.Title>Unlink Account</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						Are you sure you want to unlink <strong>{unlinkProfileName}</strong>?
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={() => setShowUnlinkModal(false)}>
							Cancel
						</Button>
						<Button variant="danger" onClick={() => unlinkAccount(unlinkProfile)}>	
							Unlink
						</Button>
					</Modal.Footer>
				</Modal>

            </Tab.Pane>

            {/* Billing Tab */}
            <Tab.Pane eventKey="billing">


			  {Object.keys(profile.cards).length > 0 ? (
				<div>
					<h5>Your Cards</h5>
					<div className="card p-3 mb-3">
						{Object.values(profile.cards).map((card, index) => (
							<div key={index} className="d-flex justify-content-between align-items-center mb-2">
								<div>
									{card.cardnumber.startsWith('3') && <i className="fab fa-cc-amex text-primary me-2"></i>}
									{card.cardnumber.startsWith('4') && <i className="fab fa-cc-visa text-primary me-2"></i>}
									{card.cardnumber.startsWith('5') && <i className="fab fa-cc-mastercard text-black me-2"></i>}
									{!card.cardnumber.startsWith('3') && !card.cardnumber.startsWith('4') && !card.cardnumber.startsWith('5') && 
										<i className="fas fa-credit-card text-black me-2"></i>
									}
									•••• •••• •••• {card.cardnumber.slice(-4)}
									<small className="text-muted ms-2">Expires: {card.exp}</small>
								</div>
								<div>
									<OverlayTrigger
										placement="top"
										overlay={
											<Tooltip>
												{Object.values(profile.socials).some(social => social.cardid == card.cardid) ? 
													"This card is linked to an active subscription and cannot be deleted" :
													"Delete this card"
												}
											</Tooltip>
										}
									>
										<span>
											<Button 
												variant="danger" 
												size="sm" 
												onClick={() => {
													if (!Object.values(profile.socials).some(social => social.cardid == card.cardid)) {
														deleteCard(profile.profileid, card.cardid);
													}
												}}
												disabled={Object.values(profile.socials).some(social => social.cardid == card.cardid)}
											>
												<i className="fas fa-trash"></i>
											</Button>
										</span>
									</OverlayTrigger>
								</div>
							</div>
						))}
						<Button variant="instagram" className="bg-instagram text-white mt-3" onClick={handleOpenModal}>
						<i className="fas fa-plus me-2 "></i>
						Add New Card
					</Button>
				
					</div>

				
				</div>
			  ) : (
				<Form className="card p-3 mb-3">
					<h5>Add a new card</h5>
					<Form.Group controlId="formCardNumber" className="mb-3">
						<Form.Label className="text-muted small mb-2">
							<i className="far fa-credit-card me-2"></i>
							Card Number
						</Form.Label>
						<Form.Control
							as={InputMask}
							type="text"
							value={cardNumber}
							placeholder="•••• •••• •••• ••••"
							maskChar=""
							mask="9999 9999 9999 9999"
							onChange={(e) => setCardNumber(e.target.value)}
							className="form-control-lg"
						/>
					</Form.Group>

					<div className="row">
						<div className="col-md-6">
							<Form.Group controlId="formCardExpiry" className="mb-3">
								<Form.Label className="text-muted small mb-2">
									<i className="far fa-calendar me-2"></i>
									Expiration Date
								</Form.Label>
								<Form.Control
									as={InputMask}
									type="text"
									placeholder="MM/YY"
									mask="99/99"
									value={cardExpiry}
									onChange={(e) => setCardExpiry(e.target.value)}
									className="form-control-lg"
								/>
							</Form.Group>
						</div>
						<div className="col-md-6">
							<Form.Group controlId="formCardCvc" className="mb-3">
								<Form.Label className="text-muted small mb-2">
									<i className="fas fa-lock me-2"></i>
									Security Code
								</Form.Label>
								<Form.Control
									as={InputMask}
									type="text"
									placeholder="•••"
									mask="999"
									value={cardCvc}
									onChange={(e) => setCardCvc(e.target.value)}
									className="form-control-lg"
								/>
							</Form.Group>
						</div>
					</div>

					<Button variant="primary" onClick={handleSaveBilling}>
						<i className="fas fa-plus me-2"></i>
						Add Card
					</Button>
				</Form>
			  )}
			  <h5>Subscription Information</h5>
              {Object.values(profile.socials).map((social, index) => (
                <div key={index} className="card p-3 mb-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-start w-100">
                      <div className="position-relative me-3">
                        <img 
                          src={social.photo || defaultPhoto}
                          alt={social.username}
                          className="rounded-circle"
                          style={{width: "50px", height: "50px", objectFit: "cover"}}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-2">
                          {social.platform === 'instagram' && (
                            <i className="fab fa-instagram text-instagram me-2"></i>
                          )}
                          {social.platform === 'tiktok' && (
                            <i className="fab fa-tiktok text-tiktok me-2"></i>
                          )}
                          {social.platform === 'youtube' && (
                            <i className="fab fa-youtube text-red-500 me-2"></i>
                          )}
						  {social.platform === 'x' && (
                            <span className="bg-black px-1 rounded-md text-white text-sm me-2">𝕏</span>
                          )}
                          {social.name || social.username}
                        </h6>
                        <div className="row">
                          <div className="col-md-6">
                            <p className="mb-2">
                              <strong>Status:</strong> <span className={`badge ${social.endDate ? 'bg-danger' : social.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>
                                {(social.endDate ? 'CANCELLED' : social.status || 'INACTIVE').toUpperCase()}
                              </span>
                            </p>

                            <p className="mb-2">
                              <strong>Plan:</strong> <span className={`badge ${social.planName === 'pro' ? 'bg-instagram' : social.planName === 'basic' ? 'bg-dark' : 'bg-secondary'}`}>
                                {(social.planName || 'NO PLAN').toUpperCase()}
                              </span>
                            </p>
							
                            {social.endDate ? (
                              Math.ceil((new Date(social.endDate) - new Date()) / (1000 * 60 * 60 * 24)) > 0 && (
                                <p className="mb-2">
                                  <strong>Expires:</strong> {Math.ceil((new Date(social.endDate) - new Date()) / (1000 * 60 * 60 * 24))} days
                                </p>
                              )
                            ) : social.nextChargeDate && (
                              <div>
                                <p className="mb-2">
                                  <strong>Days Remaining:</strong> {Math.ceil((new Date(social.nextChargeDate) - new Date()) / (1000 * 60 * 60 * 24))} days
                                </p>
                              </div>
                            )}
							{social.status === 'skipped' && (
								<Button variant="success" size="sm" onClick={() => window.location.href = '/dashboard/settings?tab=invoices'}>
									PAY INVOICE
								</Button>
							)}
                          </div>
                          {social.planName && !social.endDate && (
                            <div className="col-md-6 position-relative">
								
                              <p className="mb-2">
                                <strong>Next Charge:</strong> {social.nextChargeDate ? new Date(social.nextChargeDate).toLocaleDateString() : 'No active subscription'}
                              </p>
                              <p className="mb-2">
                                <strong>Plan Interval:</strong> {(social.planInterval || 'N/A').split('').map((char, i) => i === 0 || social.planInterval[i-1] === ' ' ? char.toUpperCase() : char.toLowerCase()).join('')}
                              </p>
                              <p className="mb-2">
                                <strong>Started On:</strong> {social.createdAt ? new Date(social.createdAt).toLocaleDateString() : 'No active subscription'}
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="mt-3">
                          <div className="d-flex flex-wrap gap-2 align-items-center">
						  {social.status === 'active' && (
                            <Dropdown className="d-inline-block" align="end" drop="up">
                              <Dropdown.Toggle variant="light" size="sm">
                                {social.cardid ? (
                                  <>
                                    {profile.cards[social.cardid].cardnumber.startsWith('3') && <i className="fab fa-cc-amex text-primary me-2"></i>}
                                    {profile.cards[social.cardid].cardnumber.startsWith('4') && <i className="fab fa-cc-visa text-primary me-2"></i>}
                                    {profile.cards[social.cardid].cardnumber.startsWith('5') && <i className="fab fa-cc-mastercard text-black me-2"></i>}
                                    {profile.cards[social.cardid].cardnumber}
                                  </>
                                ) : (
                                  <>
                                    <i className="fas fa-credit-card me-2"></i>
                                    Select a card
                                  </>
                                )}
                              </Dropdown.Toggle>
                              <Dropdown.Menu style={{maxHeight: '200px', overflowY: 'auto', position: 'absolute', zIndex: 1000}}>
                                {Object.entries(profile.cards).map(([cardId, card]) => (
                                  <Dropdown.Item
                                    key={cardId}
                                    onClick={() => handleCardChange(social.profileid, cardId)}
                                    active={cardId == social.cardid}
                                    className={`${cardId == social.cardid ? "bg-black text-white" : ""}`}
                                  >
                                    {card.cardnumber.startsWith('3') && <i className={`fab fa-cc-amex ${cardId == social.cardid ? "text-white" : "text-primary"} me-2`}></i>}
                                    {card.cardnumber.startsWith('4') && <i className={`fab fa-cc-visa ${cardId == social.cardid ? "text-white" : "text-primary"} me-2`}></i>}
                                    {card.cardnumber.startsWith('5') && <i className={`fab fa-cc-mastercard ${cardId == social.cardid ? "text-white" : "text-black"} me-2`}></i>}
                                    {!card.cardnumber.startsWith('3') && !card.cardnumber.startsWith('4') && !card.cardnumber.startsWith('5') && 
                                      <i className={`fas fa-credit-card ${cardId == social.cardid ? "text-white" : "text-black"} me-2`}></i>
                                    }
                                    {card.cardnumber}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
							)}
                            {social.status === 'active' && social.endDate == null && (
                              <>
                                {social.planName === 'basic' && (
                                  <Button 
                                    href="/dashboard/upgrade"
                                    size="sm"
                                    className="d-flex text-decoration-none text-white align-items-center bg-instagram"
                                  >
                                    <i className="fas fa-arrow-up me-2"></i>
                                    Upgrade
                                  </Button>
                                )}
                                <Button 
									onClick={() => handlePauseSubscription(social.subscriptionid)}
                                  variant="danger"
                                  size="sm"
                                  className="d-flex align-items-center"
                                >
                                  <i className="fas fa-pause me-2"></i>
                                  Pause
                                </Button>
                              </>
                            )}
							{social.endDate != null && (
								<Button 
									onClick={() => handleResumeSubscription(social.subscriptionid)}
									variant="success"
									size="sm"
									className="d-flex align-items-center"
								>
									<i className="fas fa-play me-2"></i>
									Resume
								</Button>
							)}
								
                         
                            {social.status === 'inactive' || social.endDate && (
                              <Button 
                                href="/dashboard/upgrade"
                                size="sm"
                                className="d-flex text-decoration-none text-white align-items-center bg-instagram"
                              >
                                <i className="fas fa-crown me-2"></i>
                                Subscribe to Pro
                              </Button>
                            )}

							
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              
            </Tab.Pane>

            
          </Tab.Content>

		  <Modal show={showPayInvoiceModal} onHide={() => setShowPayInvoiceModal(false)}>
			<Modal.Header closeButton>
				<Modal.Title>Pay Invoice</Modal.Title>
				
			</Modal.Header>
			<Modal.Body>
				<div className="alert alert-info mb-3">
					<i className="fas fa-info-circle me-2"></i>
					Your subscription will reactivate from today and be valid for the next 30 days
				</div>
				<Card className="shadow-sm">
					<Card.Body>
						<Form>
							{/* Card Selection */}
							<Form.Group className="mb-3">
								<Form.Label>Payment Method</Form.Label>

								{/* Existing Cards Dropdown */}
								<div className="mb-3" style={{ maxHeight: "360px", overflowY: "auto" }}>
									{Object.entries(profile.cards).map(([id, card]) => (
										<div 
											key={id} 
											className={`saved-card-option p-3 rounded-lg mb-2 hover:border-instagram cursor-pointer transition-all ${selectedCard === id ? 'border-instagram' : ''}`}
											onClick={() => setSelectedCard(id)}
										>
											<Form.Check
												type="radio" 
												name="savedCard"
												id={`card-${id}`}
												className="d-none"
												onChange={() => setSelectedCard(id)}
												checked={selectedCard === id}
											/>
											<div className="d-flex align-items-center gap-2">
												<div className="rounded-full bg-instagram/10 p-2">
													{card.cardnumber.startsWith('4') && <i className="fa-brands fa-cc-visa text-instagram"></i>}
													{card.cardnumber.startsWith('5') && <i className="fa-brands fa-cc-mastercard text-instagram"></i>}
													{card.cardnumber.startsWith('3') && <i className="fa-brands fa-cc-amex text-instagram"></i>}
													{!card.cardnumber.startsWith('3') && !card.cardnumber.startsWith('4') && !card.cardnumber.startsWith('5') && <i className="fa-solid fa-credit-card text-instagram"></i>}
												</div>
												<span className="font-medium">
													•••• {card.cardnumber.slice(-4)} ({card.exp})
												</span>
											</div>
										</div>
									))}

									<div 
										className={`saved-card-option p-3 rounded-lg mb-2 hover:border-instagram cursor-pointer transition-all ${selectedCard === 'addCard' ? 'border-instagram' : ''}`}
										onClick={() => setSelectedCard('addCard')}
									>
										<Form.Check
											type="radio"
											name="savedCard" 
											id="card-new"
											className="d-none"
											onChange={() => setSelectedCard('addCard')}
											checked={selectedCard === 'addCard'}
										/>
										<div className="d-flex align-items-center gap-2">
											<div className="rounded-full bg-instagram/10 p-2">
												<i className="fa-solid fa-plus text-instagram"></i>
											</div>
											<span className="font-medium">
												Add New Card
											</span>
										</div>
									</div>
								</div>
							</Form.Group>

							{/* New Card Form */}
							{(profile.cards.length == 0 || selectedCard == 'addCard') && (
								<div className="new-card-form">
									<InputGroup className="mb-3">
										<InputGroup.Text>
											<i className="fa-solid fa-credit-card text-instagram" />
										</InputGroup.Text>
										<Form.Control
											as={InputMask}
											type="text"
											ref={cardRef}
											placeholder="Card Number"
											mask="9999 9999 9999 9999"
											maskChar=""
											required
										/>
									</InputGroup>

									<div className="d-flex gap-3 mb-3">
										<InputGroup>
											<InputGroup.Text>
												<i className="fa-solid fa-calendar text-instagram" />
											</InputGroup.Text>
											<Form.Control
												as={InputMask}
												maskChar=""
												type="text"
												ref={expRef}
												placeholder="MM/YY"
												mask="99/99"
												required
											/>
										</InputGroup>

										<InputGroup>
											<InputGroup.Text>
												<i className="fa-solid fa-lock text-instagram" />
											</InputGroup.Text>
											<Form.Control
												as={InputMask}
												maskChar=""
												type="text"
												ref={cvvRef}
												placeholder="CVV"
												mask="9999"
												required
											/>
										</InputGroup>
									</div>
								</div>
							)}

							<Button
								variant="primary"
								className="w-100 bg-instagram border-0 hover:bg-instagram/90"
								disabled={isLoading}
								onClick={() => handlePayInvoice(
									selectedInvoice?.invoiceid,
									selectedCard,
									expRef.current?.value,
									cvvRef.current?.value,
									cardRef.current?.value
								)}
							>
								{isLoading ? 'Processing...' : `Pay $${selectedInvoice?.price}`}
							</Button>
						</Form>
					</Card.Body>
				</Card>
			</Modal.Body>
		  </Modal>

		  
		  <Tab.Pane eventKey="invoices">	

			<table className="table border">
				<thead>
					<tr>
						<th>Invoice ID</th>
					
						<th>Profile Name</th>
						<th>Amount</th>
						<th>Date</th>
						<th>Status</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{profile.invoices && Object.values(profile.invoices).length > 0 ? (
						Object.values(profile.invoices).map((invoice, index) => (
							<tr key={index}>
								<td>{invoice.invoiceid}</td>
							
								<td>{ profile.socials[invoice.profileid]?.username}</td>
								<td>${invoice.price}</td>
								<td>{new Date(invoice.createdAt).toLocaleDateString()}</td>
								<td>
									<span className={`badge ${invoice.status === 'paid' ? 'bg-success' : 'bg-danger'}`}>
										{invoice.status.toUpperCase()}
									</span>
								</td>
								<td>
									{invoice.status === 'unpaid' && (
										<Button variant="primary" size="sm" onClick={() => {
											setSelectedInvoice(invoice);
											setShowPayInvoiceModal(true);
										}}>
											Pay Now
										</Button>
									)}
								</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan="6" className="text-center">No invoices found</td>
						</tr>
					)}
				</tbody>
			</table>

					
			
		  </Tab.Pane>
        </Tab.Container>
      </Container>

      {/* Modal for Updating Card Info */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="h5 mb-0">
         
            Update Payment Method
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-4">
          <Form>
            <Form.Group controlId="formCardNumber" className="mb-4">
              <Form.Label className="text-muted small mb-2">
                <i className="far fa-credit-card me-2"></i>
                Card Number
              </Form.Label>
              <Form.Control
                as={InputMask}
                type="text"
                placeholder="•••• •••• •••• ••••"
                maskChar=""
                mask="9999 9999 9999 9999"
                onChange={(e) => setCardNumber(e.target.value)}
                className="form-control-lg"
              />
            </Form.Group>

            <div className="row">
              <div className="col-md-6">
                <Form.Group controlId="formCardExpiry" className="mb-4">
                  <Form.Label className="text-muted small mb-2">
                    <i className="far fa-calendar me-2"></i>
                    Expiration Date
                  </Form.Label>
                  <Form.Control
                    as={InputMask}
                    type="text"
                    placeholder="MM/YY"
                    mask="99/99"
                    onChange={(e) => setCardExpiry(e.target.value)}
                    className="form-control-lg"
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group controlId="formCardCvc" className="mb-4">
                  <Form.Label className="text-muted small mb-2">
                    <i className="fas fa-lock me-2"></i>
                    Security Code
                  </Form.Label>
                  <Form.Control
                    as={InputMask}
                    type="text"
                    placeholder="•••"
                    mask="999"
                    onChange={(e) => setCardCvc(e.target.value)}
                    className="form-control-lg"
                  />
                </Form.Group>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-3">
          <Button variant="light" onClick={handleCloseModal} className="px-4">
            <i className="fas fa-times me-2"></i>
            Cancel
          </Button>
          <Button variant="instagram" onClick={handleSaveBilling} className="px-4 text-white bg-instagram" disabled={isAddingCard}>
            <i className="fas fa-plus me-2"></i>
            Add Card
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for Cancel Subscription */}
      <Modal show={showCancelModal} onHide={handleCloseCancelModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Subscription Cancellation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to cancel your subscription?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCancelModal}>
            No, Keep Subscription
          </Button>
          <Button variant="danger" onClick={handleCancelSubscription}>
            Yes, Cancel Subscription
          </Button>
        </Modal.Footer>
      </Modal>

	  <Modal show={showChangePasswordModal} onHide={() => setShowChangePasswordModal(false)}>
		<Modal.Header closeButton>
			<Modal.Title>Change Password</Modal.Title>
		</Modal.Header>
		<Modal.Body >
			<Form>
				<Form.Group controlId="formNewPassword" className="mb-3">
					<Form.Label>Old Password</Form.Label>
					<Form.Control
						type="password"
						placeholder="Enter old password"
						onChange={(e) => setOldPassword(e.target.value)}
					/>
				</Form.Group>
				<Form.Group controlId="formConfirmPassword" className="mb-3">
					<Form.Label>New Password</Form.Label>
					<Form.Control
						type="password"
						placeholder="Enter new password"
						onChange={(e) => setNewPassword(e.target.value)}
					/>
				</Form.Group>
				<Form.Group controlId="formConfirmNewPassword" className="mb-3">
					<Form.Label>Confirm New Password</Form.Label>
					<Form.Control
						type="password"
						placeholder="Confirm new password"
						onChange={(e) => setConfirmPassword(e.target.value)}
					/>
				</Form.Group>
				<Button variant="primary" onClick={handleSubmitPasswordChange}>
					Save Changes
				</Button>
			</Form>
		</Modal.Body>
	  </Modal>

    </>
  );
};

export default Settings;
